import { Box, Checkbox, Fade, Form, Grid, NumberField, Select, Text, TextField } from '@approvalmax/ui/src/components';
import { useFormContext } from 'react-hook-form';
import { usePersonCountries } from 'shared/hooks/(wallets)/kyc/usePersonCountries';

import type { FormValues } from '../../AddPersonWizard.types';
import { roles } from './RoleStep.constants';
import { messages } from './RoleStep.messages';

export const RoleStep = () => {
    const { countries, isCountriesLoading } = usePersonCountries();
    const form = useFormContext<FormValues>();
    const adoptedRoles = form.watch('person.adoptedRoles');
    const verifyNeeded = form.watch('person.verifyNeeded');

    return (
        <Form.Part>
            <Grid gap={16}>
                <Select
                    required
                    name='person.adoptedRoles'
                    qa='roles'
                    label={messages.person}
                    placeholder={messages.personPlaceholder}
                    items={roles}
                />

                <Fade in={Boolean(adoptedRoles?.includes('owner'))}>
                    <Grid gridTemplateColumns='140px'>
                        <NumberField
                            required
                            clearable={false}
                            name='person.ownershipPercentage'
                            min={10}
                            max={100}
                            label={messages.ownershipPercentage}
                            placeholder={messages.ownershipPercentagePlaceholder}
                            endIcon={<span>%</span>}
                        />
                    </Grid>
                </Fade>

                <Fade in={Boolean(adoptedRoles)}>
                    <Box color='midnight20' spacing='24' radius='small'>
                        <Grid gap={16}>
                            <Text font='body' fontSize='small'>
                                {messages.inOrderToProceed}
                            </Text>

                            <Checkbox name='person.verifyNeeded' size='small'>
                                {messages.requiresVerification({
                                    role: adoptedRoles === 'owner' ? messages.ownerShort : messages.directorShort,
                                })}
                            </Checkbox>
                        </Grid>
                    </Box>
                </Fade>

                <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                    <TextField
                        required
                        name='person.firstName'
                        label={messages.firstName}
                        placeholder={messages.firstNamePlaceholder}
                    />

                    <TextField
                        name='person.middleName'
                        label={messages.middleName}
                        placeholder={messages.middleNamePlaceholder}
                    />

                    <TextField
                        required
                        name='person.lastName'
                        label={messages.lastName}
                        placeholder={messages.lastNamePlaceholder}
                    />
                </Grid>

                <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                    <TextField
                        required
                        name='person.email'
                        label={messages.email}
                        placeholder={messages.emailPlaceholder}
                    />
                </Grid>

                {!verifyNeeded && (
                    <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                        <Select
                            required
                            autocomplete
                            clearable={false}
                            name='person.homeCountry'
                            label={messages.homeCountry}
                            placeholder={messages.homeCountryPlaceholder}
                            items={countries}
                            progress={isCountriesLoading}
                        />
                    </Grid>
                )}
            </Grid>
        </Form.Part>
    );
};

RoleStep.displayName = 'RoleStep';
